import { Component, type ReactNode } from 'react'
import { Button } from '@/components/ui/button'
import { AlertTriangle } from 'lucide-react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-[400px] flex-col items-center justify-center gap-4 p-6">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/30">
            <AlertTriangle className="h-8 w-8 text-red-500" />
          </div>
          <h2 className="text-xl font-semibold">Algo salio mal</h2>
          <p className="max-w-md text-center text-sm text-muted-foreground">
            Ocurrio un error inesperado al renderizar esta seccion. Puedes intentar recargar o
            volver al inicio.
          </p>
          {this.state.error && (
            <pre className="max-w-lg overflow-auto rounded border bg-muted p-3 text-xs">
              {this.state.error.message}
            </pre>
          )}
          <div className="flex gap-2">
            <Button variant="outline" onClick={this.handleReset}>
              Reintentar
            </Button>
            <Button onClick={() => (window.location.href = '/')}>Ir al inicio</Button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
